import ErrorPageInfo from './ErrorPageInfo';

export default ErrorPageInfo;
